<template>
    <div class="star-wrapper">
        <div class="star"></div>
        <div class="star"></div>
        <div class="star"></div>
    </div>
</template>

<script>
import Vue from "vue";
export default Vue.extend({
    name: "AiLoadingAnimation"
});
</script>

<style>
.star-wrapper {
    position: relative;
    width: 30px;
    aspect-ratio: 1/1;
    transition: all;
}

.star-wrapper .star {
    position: absolute;
    width: 40%;
    aspect-ratio: 1/1;
    clip-path: polygon(33% 34%, 0 50%, 33% 69%, 50% 100%, 65% 67%, 100% 50%, 64% 33%, 50% 0);
    background: yellow;
}

.star-wrapper .star:nth-child(1) {
    top: 25%;
    animation: grow1 2s linear infinite;
    animation-delay: 0.2s;
    /* Delay for the first star */
    background: #e44aa2;
}

.star-wrapper .star:nth-child(2) {
    top: 15%;
    left: 30%;
    animation: grow2 3s linear infinite;
    animation-delay: 0.4s;
    /* Delay for the second star */
    background: #e41b51;
}

.star-wrapper .star:nth-child(3) {
    top: 50%;
    left: 18%;
    animation: grow3 4s linear infinite;
    animation-delay: 0.6s;
    /* Delay for the third star */
    background: #f17193;
}

@keyframes grow1 {
    0% {
        transform: scale(1) translateX(0);
    }

    50% {
        transform: scale(1.3) translateX(-20%);
    }

    100% {
        transform: scale(1) translateX(0);
    }
}

@keyframes grow2 {
    0% {
        transform: scale(1) translateX(0);
    }

    50% {
        transform: scale(1.3) translateX(20%) translateY(-15%);
    }

    70% {
        transform: scale(1.3) translateX(20%) translateY(-15%);
    }

    100% {
        transform: scale(1) translateX(0);
    }
}

@keyframes grow3 {
    0% {
        transform: scale(1) translateX(0);
    }

    33% {
        transform: scale(1.3) translateX(15%) translateY(25%);
    }

    50% {
        transform: scale(1.3) translateX(15%) translateY(25%);
    }

    100% {
        transform: scale(1) translateX(0);
    }
}
</style>
